import { PublicInternalAssessmentInitiationViewModel } from "../PublicInternalAssessmentTemplates.types.ts";
import { useParams } from "react-router";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function usePublicInternalAssessmentContainer() {
    const { externalId } = useParams<{ externalId: string }>();
    const url = `/publicInternalAssessmentInitiation/${externalId}`;
    let { isLoading, data } = useDotLegalQuery<PublicInternalAssessmentInitiationViewModel>(url);

    return { isLoading, data };
}
